export const COMPACT_PWA_WIDTH_QUERY = '(max-width: 900px)';
export const COMPACT_PWA_LANDSCAPE_QUERY = '(orientation: landscape) and (max-height: 520px) and (pointer: coarse)';

function getViewport(env) {
  const documentElement = env?.document?.documentElement || {};
  const width = Number(env?.innerWidth || documentElement.clientWidth || 0);
  const height = Number(env?.innerHeight || documentElement.clientHeight || 0);
  return { width, height };
}

function matchesQuery(env, query) {
  if (!env?.matchMedia) return false;
  try {
    return env.matchMedia(query).matches;
  } catch (err) {
    return false;
  }
}

function hasCoarsePointer(env) {
  return matchesQuery(env, '(pointer: coarse)')
    || Number(env?.navigator?.maxTouchPoints || 0) > 0;
}

export function getPwaViewportState({ isStandalone = false, env = typeof window !== 'undefined' ? window : {} } = {}) {
  const { width, height } = getViewport(env);
  const compactWidth = matchesQuery(env, COMPACT_PWA_WIDTH_QUERY) || (width > 0 && width <= 900);
  const landscapeCompact = matchesQuery(env, COMPACT_PWA_LANDSCAPE_QUERY)
    || (width > height && height > 0 && height <= 520 && hasCoarsePointer(env));

  return {
    isCompactPwaViewport: Boolean(isStandalone && (compactWidth || landscapeCompact)),
    isPwaLandscape: Boolean(isStandalone && landscapeCompact),
  };
}
